"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _Tag = _interopRequireDefault(require("../../Tag")),
    _tagInput = require("../styles/tagInput"),
    _LabelWrapper = _interopRequireDefault(require("../../LabelWrapper")),
    _ErrorIcon = _interopRequireDefault(require("../../ErrorIcon"));

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var TAG_JOIN = ",",
    BACKSPACE = 8,
    RETURN = 13,
    LF = 10,
    SELECT_ALL = 65,
    TagInput = function (a) {
  function b(a) {
    var d;
    (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.deleteTag = (0, _lodash["default"])(function (a) {
      return function () {
        var b = d.state.tags,
            c = b.findIndex(function (b) {
          var c = b.value;
          return c === a;
        });
        -1 >= c || (b.splice(c, 1), d.setState({
          tags: b
        }), d.onChange(b.map(function (a) {
          var b = a.value;
          return b;
        }).join(TAG_JOIN)));
      };
    }), d.componentDidMount = function () {
      d.validateDefaultValue();
    }, d.validateDefaultValue = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              if (b = d.props, c = b.validate, e = b.tagValidation, f = d.state.tags, f.length && c && e) {
                a.next = 4;
                break;
              }

              return a.abrupt("return");

            case 4:
              return a.next = 6, Promise.all(f.map(function () {
                var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
                  var c;
                  return _regenerator["default"].wrap(function (a) {
                    for (;;) {
                      switch (a.prev = a.next) {
                        case 0:
                          return c = b.value, a.t0 = c, a.next = 4, d.validateTag(c);

                        case 4:
                          return a.t1 = a.sent, a.abrupt("return", {
                            value: a.t0,
                            valid: a.t1
                          });

                        case 6:
                        case "end":
                          return a.stop();
                      }
                    }
                  }, a);
                }));
                return function () {
                  return a.apply(this, arguments);
                };
              }()));

            case 6:
              g = a.sent, d.setState({
                tags: g
              }, d.handleValidate);

            case 8:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.onChange = function (a) {
      var b = d.props.onChange;
      d.handleValidate(), "function" != typeof b || b(a);
    }, d.addCurrentTag = function (a, b) {
      return new Promise(function () {
        var c = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function c(e) {
          var f, g, h, i;
          return _regenerator["default"].wrap(function (c) {
            for (;;) {
              switch (c.prev = c.next) {
                case 0:
                  if (f = a.trim(), a.trim()) {
                    c.next = 3;
                    break;
                  }

                  return c.abrupt("return");

                case 3:
                  return g = b.map(function (a) {
                    var b = a.value;
                    return b.toUpperCase();
                  }), h = g.indexOf(f.toUpperCase()), -1 < h && b.splice(h, 1), c.next = 8, d.validateTag(f);

                case 8:
                  if (i = c.sent, b.push({
                    value: f,
                    valid: i
                  }), d.setState({
                    text: "",
                    tags: b
                  }, e), d._tagInput && d._tagInput.current) {
                    c.next = 13;
                    break;
                  }

                  return c.abrupt("return");

                case 13:
                  d._tagInput.current.scrollTo({
                    top: d._tagInput.current.scrollHeight,
                    behavior: "smooth"
                  });

                case 14:
                case "end":
                  return c.stop();
              }
            }
          }, c);
        }));
        return function () {
          return c.apply(this, arguments);
        };
      }());
    }, d.handleKeyDown = function () {
      var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
        var c, e, f, g, h, i, j;
        return _regenerator["default"].wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                if (c = d.state, e = c.tags, f = c.text, g = c.selectAll, h = b.keyCode, i = b.currentTarget, j = i.selectionEnd, !((b.ctrlKey || b.metaKey) && h === SELECT_ALL)) {
                  a.next = 5;
                  break;
                }

                return a.abrupt("return", void d.setState({
                  selectAll: !0
                }));

              case 5:
                if (d.setState({
                  selectAll: !1
                }), h === RETURN || h === LF || h === BACKSPACE) {
                  a.next = 8;
                  break;
                }

                return a.abrupt("return");

              case 8:
                if (!(h === BACKSPACE && g)) {
                  a.next = 10;
                  break;
                }

                return a.abrupt("return", void d.setState({
                  tags: [],
                  text: f
                }, function () {
                  d.onChange("");
                }));

              case 10:
                if (h !== BACKSPACE || 0 === j) {
                  a.next = 12;
                  break;
                }

                return a.abrupt("return");

              case 12:
                if (h === BACKSPACE && e.length && d.deleteTag(e.pop().value)(), h !== RETURN && h !== LF) {
                  a.next = 16;
                  break;
                }

                return a.next = 16, d.addCurrentTag(f, e);

              case 16:
                d.handleTagChange(e);

              case 17:
              case "end":
                return a.stop();
            }
          }
        }, a);
      }));
      return function () {
        return a.apply(this, arguments);
      };
    }(), d.handleInputChange = function (a) {
      var b = a.currentTarget.value,
          c = b.replace(/[,;:?! ]+/gi, " ").replace(/[^a-zA-Z0-9 @.'-]+/gi, "");
      d.setState({
        text: c
      });
    }, d.validateTag = function () {
      var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
        var c;
        return _regenerator["default"].wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                if (c = d.props.tagValidation, c) {
                  a.next = 3;
                  break;
                }

                return a.abrupt("return", !0);

              case 3:
                return a.abrupt("return", c(b));

              case 4:
              case "end":
                return a.stop();
            }
          }
        }, a);
      }));
      return function () {
        return a.apply(this, arguments);
      };
    }(), d.handleValidate = function () {
      var a = d.props.validate,
          b = d.state.tags,
          c = b.every(function (a) {
        var b = a.valid;
        return b;
      });
      d.setState({
        valid: c,
        selectAll: !1
      }), a && a(c);
    }, d.onBlur = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              if (b = d.state, c = b.text, e = b.tags, c) {
                a.next = 3;
                break;
              }

              return a.abrupt("return", void d.handleValidate());

            case 3:
              return a.next = 5, d.addCurrentTag(c, e);

            case 5:
              d.handleValidate(), f = d.state.tags, d.handleTagChange(f);

            case 8:
            case "end":
              return a.stop();
          }
        }
      }, a);
    }));
    var e = a.defaultValue;
    return d.state = {
      valid: !0,
      text: "",
      selectAll: !1,
      tags: e ? e.split(TAG_JOIN).map(function (a) {
        return {
          value: a,
          valid: !0
        };
      }) : []
    }, d._tagInput = (0, _react.createRef)(), d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "handleTagChange",
    value: function handleTagChange(a) {
      var b = a.map(function (a) {
        var b = a.value;
        return b;
      }).join(TAG_JOIN);
      this.onChange(b);
    }
  }, {
    key: "render",
    value: function render() {
      var a,
          b = this,
          c = this.state,
          d = c.text,
          e = c.valid,
          f = c.tags,
          g = c.selectAll,
          h = this.props,
          i = h.id,
          j = h.label,
          k = h.className,
          l = h.placeholder,
          m = h.disabled,
          n = h.errorMessage,
          o = h.labelProps;
      return _react["default"].createElement(_LabelWrapper["default"], (0, _extends2["default"])({}, o, {
        id: i,
        label: j,
        className: k
      }), _react["default"].createElement("div", {
        ref: this._tagInput,
        className: (0, _classnames["default"])("tag-input", (0, _tagInput.TAG_INPUT_CONTAINER)({
          valid: e,
          disabled: m
        }), k, (a = {
          "tag-input__disabled": m,
          "tag-input--selected": g
        }, (0, _defineProperty2["default"])(a, _tagInput.DISABLED_TAG_INPUT_CONTAINER, m), (0, _defineProperty2["default"])(a, _tagInput.SELECTED_TAG_INPUT_CONTAINER, g), a))
      }, f && f.length ? f.map(function (a) {
        var c = a.value,
            d = a.valid;
        return _react["default"].createElement(_Tag["default"], {
          key: c,
          tagName: c,
          onClick: b.deleteTag(c),
          valid: d,
          className: _tagInput.TAG,
          disabled: m
        });
      }) : null, _react["default"].createElement("input", {
        placeholder: l,
        type: "text",
        value: d,
        className: (0, _classnames["default"])(_tagInput.TAG_INPUT),
        onChange: this.handleInputChange,
        onKeyDown: this.handleKeyDown,
        onBlur: this.onBlur,
        disabled: m
      }), e ? null : _react["default"].createElement(_ErrorIcon["default"], {
        id: "tag-input-error-icon",
        className: (0, _classnames["default"])(_tagInput.TAG_INPUT_ERROR, "tag-input__error"),
        errorMessage: n,
        place: "left"
      })));
    }
  }]), b;
}(_react.Component);

exports["default"] = TagInput, TagInput.defaultProps = {
  defaultValue: ""
};